import { type BuilderElement } from '@builder.io/react'

export const defaultBlocks: BuilderElement[] = [
  {
    '@type': '@builder.io/sdk:Element',
    '@version': 2,
    layerName: 'Column',
    id: 'builder-84eccf1867bf47d08020c31e2f7e5b9e',
    component: {
      name: 'Columns',
      options: {
        columns: [
          {
            blocks: [],
          },
        ],
        space: 20,
        stackColumnsAt: 'tablet',
        reverseColumnsWhenStacked: false,
      },
    },
    responsiveStyles: {
      large: {
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        flexShrink: '0',
        boxSizing: 'border-box',
      },
    },
  },
]
